export default "__VITE_ASSET__2e524abd__"